import React, { FunctionComponent, useEffect } from 'react'
import { View } from 'react-native'

import { useAnimateLottie } from '../../hooks/useAnimateLottie'
import { useLazyLottieSource } from '../../hooks/useLazyLottieSource'

export interface ProviderWavingLottieProps {
  play?: boolean
  size?: number
  duration?: number // in milliseconds
  bgColor?: 'oatmeal' | 'white'
}

export const ProviderWavingLottie: FunctionComponent<ProviderWavingLottieProps> = ({
  play = false,
  size = 158,
  duration = 900,
  bgColor = 'oatmeal',
}) => {
  const { progress, playLottie, reverseLottie, AnimationView } = useAnimateLottie(duration)
  const animationData = useLazyLottieSource(
    () =>
      bgColor === 'white'
        ? import('../../assets/lottie/provider_led_white_bg.json')
        : import('../../assets/lottie/provider_led.json'),
    [bgColor],
  )

  useEffect(() => {
    if (play) {
      playLottie()
    } else {
      reverseLottie()
    }
  }, [duration, play, playLottie, reverseLottie])

  if (!animationData) {
    return <View style={{ height: size, width: size }} />
  }

  return (
    <AnimationView
      source={animationData}
      progress={progress.current}
      loop={false}
      autoPlay={false}
      style={{ height: size, width: size }}
    />
  )
}
